/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { PrescriptionFilter } from './PrescriptionFilter';

export type PrescriptionRequest = {
    filter?: PrescriptionFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: PrescriptionRequest.exposeType;
}

export namespace PrescriptionRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
